import { render, staticRenderFns } from "./ConfigMailRow.vue?vue&type=template&id=3213b654&scoped=true&"
import script from "./ConfigMailRow.vue?vue&type=script&lang=js&"
export * from "./ConfigMailRow.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMailRow.vue?vue&type=style&index=0&id=3213b654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3213b654",
  null
  
)

export default component.exports